/*
 * @Author: xianghongai@gmail.com
 * @Date: 2017-11-09 15:54:01
 * @Last Modified by: Nicholas Hsiang
 * @Last Modified time: 2017-11-22 20:08:38
 */

// bug feedback: xianghongai@gmail.com
var hs = hs || {};
hs.Captcha = function(param) {
    param = param || {};
    this.captchaForm = param.captchaForm || '#j_form_captcha';
    this.captchaWrapper = param.captchaWrapper || '.captcha-wrapper';
    this.captchaInput = param.captchaInput || '.input-captcha';
    this.captchaImg = param.captchaImg || '.captcha-img';
    this.captchaRefresh = param.captchaRefresh || '.refresh-captcha';
    this.auto = param.auto || 60000;
    this._CPTCHATEXT = "";
};

hs.Captcha.prototype._generateCaptcha = function() {
    var dataA = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    var dataLength = dataA.length;
    return dataA[Math.floor(Math.random() * dataLength)].toString();
};

hs.Captcha.prototype._randomColor = function() {
    return "#" + ((1 << 24) * Math.random() | 0).toString(16);
};

hs.Captcha.prototype._angle = function() {
    var dataA = [-35, -25, -15, 0, 15, 25, 35];
    var dataLength = dataA.length;
    return dataA[Math.floor(Math.random() * dataLength)];
};

hs.Captcha.prototype.createCaptcha = function() {
    var _this = this;
    var tplTemp = "";
    var i = 1;
    var j = 1;

    var $captchaForm = $(_this.captchaForm);
    var $captchaWrapper = $captchaForm.find(_this.captchaWrapper);
    var $captchaImg = $captchaWrapper.find(_this.captchaImg);

    for (i = 1; i < 5; i++) {
        tplTemp += '<span class="code' + i + '">' + _this._generateCaptcha() + '</span>';
    }

    $captchaImg.html(tplTemp);

    _this.CPTCHATEXT = $captchaImg.text();

    for (j = 1; j < 5; j++) {
        $captchaImg.children('.code' + j).css({
            'color': _this._randomColor(),
            '-webkit-transform': 'rotate(' + _this._angle() + 'deg)',
            'transform': 'rotate(' + _this._angle() + 'deg)',
        });
    }

    tplTemp = "";

};

hs.Captcha.prototype.init = function() {
    var _this = this;

    var $captchaForm = $(_this.captchaForm);
    var $captchaInput = $captchaForm.find(_this.captchaInput);
    var $captchaWrapper = $captchaForm.find(_this.captchaWrapper);
    var $captchaImg = $captchaWrapper.find(_this.captchaImg);
    var $captchaRefresh = $captchaWrapper.find(_this.captchaRefresh);

    // 来一次
    _this.createCaptcha();


    // 每隔一段时间来一次
    setInterval(function() {
        _this.createCaptcha();
    }, _this.auto);

    $captchaImg.on('click', function() {
        _this.createCaptcha();
    });

    $captchaRefresh.on('click', function() {
        _this.createCaptcha();
    });

    function verifyNotify(msgType, msg) {
        $captchaForm.find('.form-verify-captcha').detach().end().prepend('<span class="form-verify-captcha"><i class="iconfont icon-verify-' + msgType + '" title="' + msg + '"></i></span>');
    }

    $captchaInput.on("blur", function() {
        if ($(this).val().toLocaleLowerCase() !== _this.CPTCHATEXT.toLocaleLowerCase()) {
            verifyNotify('error', '检验码不正确');
        } else {
            verifyNotify('success', '检验码正确');
        }
    });

    $captchaInput.on("keyup", function() {
        var valTemp = $(this).val();
        if (valTemp.length > 3) {
            if (valTemp.toLocaleLowerCase() !== _this.CPTCHATEXT.toLocaleLowerCase()) {
                verifyNotify('error', '检验码不正确');
            } else {
                verifyNotify('success', '检验码正确');
            }
        }
    });

};